import React from 'react';

import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { JobDetailsContainerStyled } from './style';

type WorkApproachDataType = {
  workApproach: string;
  riskAssessment: string;
  designApproach: string;
};

const WorkApproach = ({
  workApproach,
  riskAssessment,
  designApproach,
}: WorkApproachDataType) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title"
        fontColor="secondary"
        strong
      >
        WORK APPROACH
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Work Approach :</Typography>
          <Typography className="value">{workApproach}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">
            Risk Assessment :
          </Typography>
          <Typography className="value">{riskAssessment}</Typography>
        </InfoRowStyled>

        <InfoRowStyled>
          <div style={{ display: 'block' }}>
            <Typography className="title">Design Approach :</Typography>
            <Typography className="value">{designApproach}</Typography>
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};

export default WorkApproach;
